'use es6';

import getIn from 'transmute/getIn';
export const getOfficeHoursStartTime = message => getIn(['metadata', 'officeHoursStartTime'], message);
export const getNewOfficeHoursStartTime = message => getIn(['officeHoursStartTime'], message);